<ziro-breadcrumbs [labelParam]="licenseTier">
  <ziro-breadcrumb-card-item>
    @if (!isReadOnly) {
      <div
        [innerHtml]="
          'tkey;reports.cucm_license_optimizer.candidates.description'
            | escapeHtml
              : {
                  licenseType: licenseTier,
                  callRetentionDays: cdrRetentionInDays,
                  newDeviceMaxAge: newDeviceMaxAgeInDays,
                }
        "
      ></div>
    }

    @if (isReadOnly) {
      <div
        [innerHtml]="
          'tkey;reports.cucm_license_optimizer.candidates.description.read_only'
            | escapeHtml
              : {
                  licenseType: licenseTier,
                  callRetentionDays: cdrRetentionInDays,
                  newDeviceMaxAge: newDeviceMaxAgeInDays,
                }
        "
      ></div>
    }
  </ziro-breadcrumb-card-item>
</ziro-breadcrumbs>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading && data.length > 0) {
  <ziro-datatable
    [class]="'ziro-card'"
    [isCondensed]="true"
    [columns]="columns"
    [rowDataSource]="data"
    [uniqueRowIdentifier]="'id'"
    [showSelectColumn]="!isReadOnly"
    [stickyColumnCount]="1"
    [mainFilterPlaceholder]="'tkey;reports.cucm_license_optimizer.candidates.search_placeholder' | translate"
    (rowSelected)="updateBottomNav()"
    [dataAutomation]="tableDataAutomation"
  >
    <ziro-datatable-multi-select-filter
      [label]="'tkey;reports.cucm_license_optimizer.candidates.device_model'"
      [items]="deviceModelOptions"
      [matchFn]="isDeviceModelMatch"
      [dataAutomation]="'cucm-license-optimization-candidates-model-filter'"
      [tableId]="tableDataAutomation"
    ></ziro-datatable-multi-select-filter>
  </ziro-datatable>
}
